import { render, staticRenderFns } from "./ModalRemove.vue?vue&type=template&id=7b8e8727&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"
import style0 from "./ModalRemove.vue?vue&type=style&index=0&id=7b8e8727&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e8727",
  null
  
)

export default component.exports